import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./shared/styles/animations.css";
import App from "./App";
import { AnimationProvider } from "./shared/context/AnimationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AnimationProvider>
      <App />
    </AnimationProvider>
  </React.StrictMode>
);
